class BrowserFeatures {
  static hasTouch() {
    if('ontouchstart' in document.documentElement) {
      return true
    }
    else {
      return false
    }
  }
}

export default BrowserFeatures;